import React, { useState, useRef, useEffect } from 'react'
import { MenuIconThin } from '@cmsgov/ds-medicare-gov'
import { Drawer } from '../Drawer/Drawer'
import { useTranslation } from 'react-i18next'
import { MobileResourceNavItem } from '../../models/Navigation'
import events, { Event } from 'pubsub/events'
import { Categories } from 'constants/analytics'
import { getUserLoggedInState } from '../../redux/reducers/users'
import { useDispatch, useSelector } from 'react-redux'
import i18n from 'i18n/config'
import { getOpenModal, setOpenModal } from 'redux/reducers/header'
import { PrimaryNav } from './PrimaryNav/PrimaryNav'

export interface MobileNavigationProps {
  className?: string;
  loginUrl: string;
  logoutUrl: string;
  navLists: (MobileResourceNavItem)[][];
  languageToggleLink: string;
  disableLogin: boolean;
  enableMessageCenter: boolean;
}

export const MobileNavigation: React.FC<MobileNavigationProps> = ({ loginUrl, logoutUrl, disableLogin, navLists, className, languageToggleLink, enableMessageCenter }) => {
  const [subNav, setSubNav] = useState<any | undefined>(undefined)
  const openBtnRef: React.RefObject<HTMLButtonElement> = useRef<HTMLButtonElement>(null)
  const isLoggedIn = useSelector(getUserLoggedInState)
  const currentOpenModal = useSelector(getOpenModal)
  const dispatch = useDispatch()

  useEffect(() => {
    if (currentOpenModal === '') {
      setSubNav(undefined)
    }
  }, [currentOpenModal])

  const handleMenuButtonClick = () => {
    if (currentOpenModal !== '') {
      handleCloseButtonClick()
    } else {
      dispatch(setOpenModal('mobileMenu'))

      const options: Event = {
        text: 'Menu',
        authenticated: isLoggedIn,
        category: Categories.MobileNav,
        targetLocation: 'Open mobile navigation',
        activity: 'Button Click',
        url: window.location.href,
        language: i18n.language,
        title: document.title,
        sendToTealium: true,
        sendToCoreAPI: true,
        isMessageCenter: false
      }
      events.publish(options)
    }
  }

  const handleCloseButtonClick = () => {
    dispatch(setOpenModal(''))
    setSubNav(undefined)

    if (openBtnRef.current) openBtnRef.current.focus()

    const options: Event = {
      text: 'X',
      authenticated: isLoggedIn,
      category: Categories.MobileNav,
      targetLocation: 'Close mobile navigation',
      activity: 'Button Click',
      url: window.location.href,
      language: i18n.language,
      title: document.title,
      sendToTealium: true,
      sendToCoreAPI: true,
      isMessageCenter: false
    }

    events.publish(options)
  }
  const { t } = useTranslation('common')
  const isOpen = currentOpenModal.startsWith('mobile')
  return (
    <>
      <nav aria-label={t(`nav.Mobile Menu`)}>
        <button
          // TODO: Redesign this button to match the current design system button styles
          className='ds-c-button ds-c-button--alternate ch-c-button--mobile-menu ch-u-remove--lg'
          onClick={handleMenuButtonClick}
          ref={openBtnRef}
          data-testid='mobile-nav-trigger'
          aria-expanded={currentOpenModal !== ''}
          type='button'
        >
          <span className='nav-menu-button-content-container ds-u-display--flex ds-u-align-items--center'>
            <MenuIconThin data-testid='veggieburger' className='ch-c-button--space-between' />
            Menu
          </span>
        </button>
        {isOpen
          ? (
              <Drawer className={className} title='Menu' onClose={handleCloseButtonClick}>
                {subNav || (
                  <PrimaryNav
                    enableMessageCenter={enableMessageCenter}
                    handleCloseButtonClick={handleCloseButtonClick}
                    onNavOptionClick={setSubNav}
                    disableLogin={disableLogin}
                    loginUrl={loginUrl}
                    logoutUrl={logoutUrl}
                    navLists={navLists}
                    languageToggleLink={languageToggleLink}
                  />
                )}
              </Drawer>
            )
          : null
        }
      </nav>
    </>
  )
}
